import { HorizontalBar, mixins } from "vue-chartjs";
const {getImageURL} = require("@/components/General/utils")
export default {
  name: "horizontal-bar-chart",
  extends: HorizontalBar,
  props: {
    chartData: {
      type: Object,
    },
    extraOptions: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  mixins: [mixins.reactiveProp],
  mounted() {
    this.$watch(
      "chartData",
      (newVal) => {
        if (newVal && newVal.length) {
          this.renderChart(newVal, this.extraOptions);
        }
      },
      { immediate: true }
    );

    this.$watch(
      "extraOptions",
      (newVal) => {
        if (newVal && newVal.length) {
          this._chart.destroy();
          this.renderChart(this.chartData, newVal);
        }
      },
      { immediate: true }
    );

    this.addPlugin({
      id: "image-label",
      afterDraw: (chart) => {
        var ctx = chart.chart.ctx;
        // var xAxis = chart.scales["x-axis-0"];
        var yAxis = chart.scales["y-axis-0"];
        yAxis.ticks.forEach((value, index) => {
          var y = yAxis.getPixelForTick(index);
          // var x = xAxis.getPixelForTick(index);

          let images = this.chartData.images;
          if (images && images[index]) {
            var image = new Image();
            image.src = getImageURL(images[index].file)
            image.onload = function(){
              ctx.drawImage(
                image,
                40,
                y - 30,
                images[index].width,
                images[index].height
              );
            }
          }
        });
      },
    });

    this.addPlugin({
      id: "click-event",
      afterEvent: (chart, args) => {
        if (args.type == "click") {
          var yTop = chart.chartArea.top;
          var yBottom = chart.chartArea.bottom;

          var yMin = 0;
          var yMax = this.chartData.labels.length - 1;

          var newY = 0;
          if (args.native.offsetY <= yBottom && args.native.offsetY >= yTop) {
            newY = Math.abs((args.native.offsetY - yTop) / (yBottom - yTop));
            newY = (newY - 1) * -1;
            newY = newY * Math.abs(yMax - yMin) + yMin;
          }
          newY = Math.abs(newY - yMax);

          var xTop = chart.chartArea.left;
          var xBottom = chart.chartArea.right;
          var xMin = chart.scales["x-axis-0"].min;
          var xMax = chart.scales["x-axis-0"].max;
          var newX = 0;

          if (args.native.offsetX <= xBottom && args.native.offsetX >= xTop) {
            newX = Math.abs((args.native.offsetX - xTop) / (xBottom - xTop));
            newX = newX * Math.abs(xMax - xMin) + xMin;
          }
          let stepX = this.extraOptions.scales.xAxes[0].ticks.stepSize;

          for (let i = 0; i <= this.chartData.bars.length - 1; i++) {
            if (
              Math.round(newY) == i &&
              this.chartData.bars[i].is_user_select_points
            ) {
              this.$emit("data", {
                index: Math.round(newY),
                value: Math.round(newX / stepX) * stepX,
              });

              this.chartData.datasets[0].data[Math.round(newY)] = Math.round(
                Math.round(newX / stepX) * stepX
              );
              this.renderChart(this.chartData, this.extraOptions);
            }
          }
        }
      },
    });

    this.renderChart(this.chartData, this.extraOptions);
  },
};
